import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormField } from '../Generic'
import { Input } from '../../form'
import { useTranslation } from 'react-i18next'
import { Befehl31FormData } from './schema'
import { useMemo } from 'react'

export interface Feld31_17FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings?: boolean
  errors?: FieldErrors
}

export default function Feld31_17Form({
  readOnly,
  'data-testid': testId,
  errors,
  activateEmptyFieldWarnings = false
}: Readonly<Feld31_17FormProps>) {
  const { t } = useTranslation('ui-befehle')

  const { control, formState } = useFormContext<Befehl31FormData>()

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  return (
    <div className="flex flex-col">
      <BefehlFormField
        name="auftrag_31_10.feld31_17"
        control={control}
        label={t('befehle.31.text.uhrzeit')}
        readOnly={readOnly}
        activateEmptyWarning={activateEmptyFieldWarnings}
        data-testid={testId}
        render={({ field }) => (
          <Input
            {...field}
            name={field.name}
            label={t('befehle.31.text.uhrzeit')}
            errors={fieldErrors}
            className="w-full"
            data-testid={`${testId}-inner`}
          />
        )}
      />
      <div>
        <span data-testid={`${testId}-label`}>
          {t('befehle.31.label.feld31_17')}
        </span>
      </div>
    </div>
  )
}
